module.exports = __webpack_public_path__ + "assets/normal/images/wheat_ear_right.745ad7fe.png";